const PRESCRIPTION_UTTERANCES = ['utter_ask_drug_name', 'utter_ask_prescription_picture']
const PRESCRIPTION_ELSEWHERE_MESSAGE = ['Somewhere else', 'Autre part']

const GYN_SEXUAL_HEALTH_GROUP_IDS = ['urology_gynecology', 'sexual_health']

const isPostSomewhereElse = (post) => {
  return PRESCRIPTION_ELSEWHERE_MESSAGE.includes(post?.message)
}

export const checkIsPrescriptionFlow = (posts, questionPost) => {
  if (!PRESCRIPTION_UTTERANCES.includes(questionPost?.props?.utterance)) {
    return false
  }

  if (posts) {
    return Object.values(posts).findIndex(isPostSomewhereElse) !== -1
  }

  return false
}

export const checkIsGynOrSexualHealthFlow = (posts) => {
  if (posts) {
    return (
      Object.values(posts).findIndex((post) =>
        GYN_SEXUAL_HEALTH_GROUP_IDS.includes(post?.props?.selected_choice?.group_id)
      ) !== -1
    )
  }

  return false
}

export const checkIsProviderSelectionSurveyEnabled = (posts, lastPost) => {
  if (posts) {
    let isProviderSelectionFlow = false
    let memberJustBooked = false
    Object.values(posts).forEach((post) => {
      if (post.props?.type === 'prompt_provider_list') {
        isProviderSelectionFlow = true
      }
    })
    if (lastPost?.props?.utterance === 'utter_open_chat_for_mhs_appointment') {
      memberJustBooked = true
    }
    return isProviderSelectionFlow && memberJustBooked
  }

  return false
}

/**
 * Extracts the region from address components returned by Google Places API
 *
 * @param addressComponents - Array of address components from Google Places
 * @returns The region code in format "CA-ON" or "US-TX" or null if not found
 */
export const extractRegionFromAddressComponents = (addressComponents) => {
  if (!addressComponents || !Array.isArray(addressComponents)) return null

  const regionComponent = addressComponents.find((component) =>
    component.types?.includes('administrative_area_level_1')
  )

  const region = regionComponent?.short_name
  if (!region) return null

  // prepend country code if region doesn't contain a "-"
  if (!region.includes('-')) {
    const countryComponent = addressComponents.find((component) =>
      component.types?.includes('country')
    )
    const countryCode = countryComponent?.short_name || 'CA'
    return `${countryCode}-${region}`
  }

  return region
}

/**
 * Checks if there's a region change based on user address input
 * Automatically detects the type of address object and extracts region accordingly
 *
 * @param addressObject - The address object (NormalizedPlace, IntakePostProps responses, or direct address)
 * @param currentRegion - The current region of the user
 * @returns The new region code if changed and should trigger update, null otherwise
 */
export const checkAddressRegionChange = (addressObject, currentRegion) => {
  if (!currentRegion || !addressObject) return null

  let newRegion = null

  // check if it's a NormalizedPlace (from non-FSUI AddressPicker)
  if (addressObject.placeID && addressObject.addressComponents) {
    newRegion = extractRegionFromAddressComponents(addressObject.addressComponents)
  }
  // check if it's IntakePostProps responses (from FSUI IntakeScreen)
  else if (Array.isArray(addressObject)) {
    const addressResponse = addressObject.find(
      (response) => response.type === 'prompt_address_response' && response.selected_address
    )
    if (addressResponse) {
      newRegion = extractRegionFromAddressComponents(
        addressResponse.selected_address.address_components
      )
    }
  }
  // check if it's a direct address object with address_components
  else if (addressObject.address_components) {
    newRegion = extractRegionFromAddressComponents(addressObject.address_components)
  }

  return newRegion && newRegion !== currentRegion ? newRegion : null
}

// Helper function to extract file IDs from various formats
export const extractFileIds = (fileObj) => {
  if (!fileObj) return []

  // Array of fileIds (strings)
  if (Array.isArray(fileObj)) {
    if (fileObj.length === 0) return []

    // Array of strings (fileIds directly)
    if (typeof fileObj[0] === 'string') {
      return fileObj
    }

    // Array of objects with fileId property
    if (fileObj[0]?.fileId) {
      return fileObj.map((f) => f.fileId).filter(Boolean)
    }

    return []
  }

  // Single object with fileId
  if (fileObj.fileId) {
    return [fileObj.fileId]
  }

  return []
}
